import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'

import i18n from '../../../i18n'

const useStyles = makeStyles({
  closeButton: {
    alignSelf: 'flex-end',
  },
  loadingContainer: {
    padding: '20px',
    minWidth: '200px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  success: {
    marginBottom: '20px',
    color: '#36942f',
    fontSize: '48px',
  },
  error: {
    marginBottom: '20px',
    color: '#ff0000',
    fontSize: '48px',
  },
})

export interface AIDraftPopupProps {
  open: boolean
  status: 'success' | 'error'
  errorMessage?: string
  onClose: () => void
}

const AIDraftPopup: React.FC<AIDraftPopupProps> = ({ open, status, errorMessage, onClose }) => {
  const classes = useStyles()

  return (
    <Dialog onClose={onClose} aria-labelledby="ai-draft-popup" open={open}>
      <IconButton
        className={classes.closeButton}
        type="button"
        edge="start"
        color="inherit"
        onClick={onClose}
        aria-label="close"
      >
        <CloseIcon />
      </IconButton>
      <Box className={classes.loadingContainer}>
        {status === 'success' ? (
          <>
            <CheckCircleOutlineIcon className={classes.success} />
            <Typography>{i18n.t('aiDraft_popup_success')}</Typography>
          </>
        ) : (
          <>
            <ErrorOutlineIcon className={classes.error} />
            <Typography>{errorMessage || i18n.t('aiDraft_popup_unknown_error')}</Typography>
          </>
        )}
      </Box>
    </Dialog>
  )
}

export default AIDraftPopup
